import { MODES } from '../hooks/useTimer';

const KEY = 'timer_snapshot';

const todayKey = () => new Date().toISOString().slice(0, 10);

/**
 * @typedef {{ date: string, mode: string, sessionCount: number, running: boolean, endAt?: number, remaining?: number }} TimerSnapshot
 */

/** @returns {TimerSnapshot | null} */
export const loadTimerSnapshot = () => {
  try {
    const raw = localStorage.getItem('vorakit_fl_' + KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (!s || s.date !== todayKey()) return null;
    if (!Object.values(MODES).includes(s.mode)) return null;
    if (typeof s.sessionCount !== 'number') return null;
    const sc = typeof s.sessionCount === 'number' ? s.sessionCount : 0;
    if (s.running && typeof s.endAt === 'number' && s.endAt > Date.now()) {
      const rem = (s.endAt - Date.now()) / 1000;
      if (rem > 0.5) return { mode: s.mode, sessionCount: sc, running: true, remaining: rem };
    }
    if (!s.running && typeof s.remaining === 'number' && s.remaining > 0.5) {
      return { mode: s.mode, sessionCount: sc, running: false, remaining: s.remaining };
    }
    return null;
  } catch {
    return null;
  }
};

/** @param {Partial<TimerSnapshot> & { remaining: number, running: boolean }} params */
export const saveTimerSnapshot = ({ mode, sessionCount, running, remaining }) => {
  const date = todayKey();
  const payload = {
    date,
    mode,
    sessionCount,
    running,
    ...(running
      ? { endAt: Date.now() + remaining * 1000 }
      : { remaining }),
  };
  try {
    localStorage.setItem('vorakit_fl_' + KEY, JSON.stringify(payload));
  } catch { /* noop */ }
};

export const clearTimerSnapshot = () => {
  try { localStorage.removeItem('vorakit_fl_' + KEY); } catch { /* noop */ }
};
